import { LoadableLazy } from '@confluence/loadable';
export type { BulkDeletePagesActionProps } from '../src/Delete/BulkDeletePagesAction';
export const BulkDeletePagesActionLoader = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-BulkDeletePagesActionLoader" */ '../src/Delete/BulkDeletePagesAction'
			)
		).BulkDeletePagesAction,
});
